import { render } from "./Ranking.vue?vue&type=template&id=378cb4b0&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"

import "./Ranking.vue?vue&type=style&index=0&id=378cb4b0&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378cb4b0"]])

export default __exports__